module.exports = __webpack_public_path__ + "img/pf.bfcc9d2.svg";